import Axios from 'axios';
import _store from '@/store';
import Env from '@/services/env.service';

export default function(path: string, body: any = {}, useAuth: boolean = true, rootUrl?: string) {
  rootUrl = rootUrl || Env.get('VUE_APP_API_ROOT');
  const token = useAuth ? _store.state.auth.authToken : '';
  let headers: any = { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' };
  if (Env.get('VUE_APP_NAMESPACE')) {
    headers['namespace'] = Env.get('VUE_APP_NAMESPACE');
  }
  if (/^\/\//.test(path) || /file:/.test(path)) throw new Error("Unsafe path for axios request");
  return Axios({
    url: rootUrl + path,
    method: 'put',
    headers: headers,
    data: body,
    withCredentials: true,
  })
    .then((res: any) => res.data,
      (err: any) => {
      // tslint:disable-next-line:no-console
      console.error(err);
      throw err;
    });
}
